import { render, staticRenderFns } from "./itemDetailPage.vue?vue&type=template&id=af48a7da&"
import script from "./itemDetailPage.vue?vue&type=script&lang=ts&"
export * from "./itemDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports